import { render } from "./ContentBanner.vue?vue&type=template&id=cd0f8cb4&scoped=true"
import script from "./ContentBanner.vue?vue&type=script&lang=js"
export * from "./ContentBanner.vue?vue&type=script&lang=js"

import "./ContentBanner.vue?vue&type=style&index=0&id=cd0f8cb4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0f8cb4"]])

export default __exports__